import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "热点复盘", to: "/topics" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-8">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              黑料热点
            </span>
            <span className="mt-0.5 text-[11px] tracking-wide text-foreground-500">
              热点事件时间线复盘
            </span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/topics"
            className="ml-3 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            最新复盘
          </Link>
        </nav>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav aria-label="移动端导航" className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-base font-medium ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}